import {filter, map, shareReplay} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {Observable} from 'rxjs';

interface WsMsg {
  uid: number;
  pushType: string;
  msgType: string;
  payload: any[];
}

export interface AuctionProjectPoolInfo {
  raisedAmountRq: string;
  remainAuctionAmountRq: string;
  commitCurrency: number;
  price: string;
  auctionEndTime: number;
  projectKey: string;
}

export const auctionProjectPoolInfo$: Observable<AuctionProjectPoolInfo> = wsMsg$.pipe(
  filter((o: WsMsg) => o.msgType === 'auction.project.pool.info'),
  map((o: WsMsg) => o.payload[0]),
  shareReplay(1)
);
